"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showWhenRowHoveredClassName = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBTableCheckbox = _interopRequireDefault(require("./HBTableCheckbox"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBTable = require("./HBTable.styles");
var _HBTableColumnHeader = require("./HBTableColumnHeader");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* eslint @typescript-eslint/switch-exhaustiveness-check: "error" */

var showWhenRowHoveredClassName = exports.showWhenRowHoveredClassName = 'show-when-row-hovered';
function HBTableCell(_ref) {
  var table = _ref.table,
    column = _ref.column,
    row = _ref.row;
  var original = column.columnDef.meta.original;
  var isPinnedColumn = (0, _HBTableColumnHeader.useIsColumnPinned)(table, column);
  var _useSortableColumn = (0, _HBTableColumnHeader.useSortableColumn)(table, column),
    setNodeRef = _useSortableColumn.setNodeRef,
    transform = _useSortableColumn.transform,
    transition = _useSortableColumn.transition,
    isDragging = _useSortableColumn.isDragging;
  return /*#__PURE__*/_react["default"].createElement(TD, {
    className: column.id,
    $width: original.width,
    $isDragging: isDragging,
    $transition: transition,
    $isPinnedColumn: isPinnedColumn,
    ref: setNodeRef,
    style: {
      transform: (0, _HBTable.getColumnTransform)(transform, isPinnedColumn) // Transform changes rapidly and causes styled components performance issues
    }
  }, /*#__PURE__*/_react["default"].createElement(_HBTable.DraggingShadow, {
    $isDragging: isDragging
  }), /*#__PURE__*/_react["default"].createElement(Container, {
    $isDragging: isDragging
  }, /*#__PURE__*/_react["default"].createElement(Checkbox, {
    table: table,
    column: column,
    row: row
  }), /*#__PURE__*/_react["default"].createElement(InnerContainer, null, original.render(row.original, showWhenRowHoveredClassName))));
}
var _default = exports["default"] = HBTableCell;
function Checkbox(_ref2) {
  var table = _ref2.table,
    column = _ref2.column,
    row = _ref2.row;
  var _table$options$meta = table.options.meta,
    helper = _table$options$meta.helper,
    bulkActions = _table$options$meta.bulkActions;
  if (column.getIndex() !== 0 || !(bulkActions !== null && bulkActions !== void 0 && bulkActions.length)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_HBTableCheckbox["default"], {
    margin: "0 8px 0 16px",
    checked: helper.isTableRowSelected(row),
    testIdName: "row",
    onChange: function onChange(e) {
      return helper.toggleTableRowSelection(row, e.target.checked);
    }
  });
}

// -------------------------- Styles -------------------------- //

var TD = _styledComponents["default"].td.withConfig({
  displayName: "HBTableCell__TD",
  componentId: "sc-j0420q-0"
})(["&&{", " padding:0;height:100%;", " background-color:", ";}"], _HBTable.draggingContainerStyles, function (_ref3) {
  var $width = _ref3.$width;
  return $width === 'fit' ? (0, _styledComponents.css)(["width:0;"]) : (0, _styledComponents.css)(["max-width:", "px;min-width:", "px;"], $width, $width);
}, function (_ref4) {
  var $isDragging = _ref4.$isDragging;
  return $isDragging ? _colors["default"].surfaceItem : 'none';
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTableCell__Container",
  componentId: "sc-j0420q-1"
})(["display:flex;align-items:center;opacity:", ";"], function (_ref5) {
  var $isDragging = _ref5.$isDragging;
  return $isDragging ? 0.5 : 1;
});
var InnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableCell__InnerContainer",
  componentId: "sc-j0420q-2"
})(["padding:10px 16px;display:flex;align-items:center;width:100%;", " > *{background-color:", ";padding:0;height:fit-content;min-height:initial;}"], _mixins.truncatedText, _colors["default"].transparent);
//# sourceMappingURL=HBTableCell.js.map